
import { cn } from "@/lib/utils";

interface GlowIndicatorProps {
  className?: string;
}

export const GlowIndicator = ({ className }: GlowIndicatorProps) => {
  return (
    <div
      className={cn(
        "absolute inset-0 overflow-hidden pointer-events-none",
        className
      )}
    >
      <div className="absolute -left-[40%] top-1/2 -translate-y-1/2 w-3/4 aspect-square rounded-full bg-primary/20 blur-3xl" />
      <div className="absolute -right-[40%] top-1/2 -translate-y-1/2 w-3/4 aspect-square rounded-full bg-primary/20 blur-3xl" />
    </div>
  );
};
